"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAdminUserActionResponseDto = instanceOfAdminUserActionResponseDto;
exports.AdminUserActionResponseDtoFromJSON = AdminUserActionResponseDtoFromJSON;
exports.AdminUserActionResponseDtoFromJSONTyped = AdminUserActionResponseDtoFromJSONTyped;
exports.AdminUserActionResponseDtoToJSON = AdminUserActionResponseDtoToJSON;
exports.AdminUserActionResponseDtoToJSONTyped = AdminUserActionResponseDtoToJSONTyped;
/**
 * Check if a given object implements the AdminUserActionResponseDto interface.
 */
function instanceOfAdminUserActionResponseDto(value) {
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    if (!('action' in value) || value['action'] === undefined)
        return false;
    return true;
}
function AdminUserActionResponseDtoFromJSON(json) {
    return AdminUserActionResponseDtoFromJSONTyped(json, false);
}
function AdminUserActionResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'userId': json['userId'],
        'action': json['action'],
    };
}
function AdminUserActionResponseDtoToJSON(json) {
    return AdminUserActionResponseDtoToJSONTyped(json, false);
}
function AdminUserActionResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'userId': value['userId'],
        'action': value['action'],
    };
}
